<template>
  <div v-loading.fullscreen.lock="loading">
    <currency-category-search-bar-component
      add_auth="新增印章使用申请类型"
      @search="get_currency_category_index"
      @addTeam="addTeam"
    ></currency-category-search-bar-component>
    <common-table-component
      details_auth="印章使用申请类型详情"
      :col_arr="fcol_arr"
      :table_data="ftable_data"
      @details_row="details_currency_category"
    ></common-table-component>
    <common-page-component
      :current_page="cond.page"
      :page_size="cond.limit"
      :total="ftotal"
      @search="get_currency_category_index"
    ></common-page-component>
    <currency-category-edit-component
      edit_auth="修改印章使用申请类型"
      del_auth="删除印章使用申请类型"
      :id="fid"
      :show_type="edit_type"
      :dialogFormVisible="fdialogFormVisible"
      :currency_category_details_data="fcurrency_category_details_data"
      @exitDialog="dialogExit"
      @search="get_currency_category_index"
      @show_edit="show_edit"
      @details_row="details_currency_category"
    ></currency-category-edit-component>
  </div>
</template>

<script>
import { currency_category_index_request,currency_category_details_request } from "@/network/finance/CurrencyCategory.js";

import CurrencyCategorySearchBarComponent from "@/components/finance/CurrencyCategory/CurrencyCategorySearchBarComponent";
import CommonTableComponent from "@/components/common/CommonTableComponent";
import CommonPageComponent from "@/components/common/CommonPageComponent";
import CurrencyCategoryEditComponent from "@/components/finance/CurrencyCategory/CurrencyCategoryEditComponent";

export default {
  name: "CurrencyCategoryView",
  data() {
    return {
      fid: 0,
      edit_type: 0,
      fdialogFormVisible: false,
      loading: false,
      ftotal: 0,
      cond: {
        name: '',
        page: 1,
        limit: 10,
      },
      ftable_data: [],
      fcol_arr: [
        {
          prop: "name",
          label: "类型名称",
          minWidth: "200px",
        },
        {
          prop: "create_staff_name",
          label: "创建人",
          minWidth: "80px",
        },
        {
          prop: "create_time",
          label: "创建时间",
          minWidth: "80px",
        }
      ],
      fcurrency_category_details_data: {},
    };
  },
  computed: {},
  methods: {
    addTeam() {
      this.edit_type = 1
      this.fdialogFormVisible = true;
    },
    show_edit() {
      this.edit_type = 2
    },
    get_currency_category_index(param = {}) {
      this.loading = true;
      this.cond.name = param.name ?? this.cond.name;
      this.cond.page = param.page ?? this.cond.page;
      if (param.limit) {
        this.cond.limit = param.limit;
        this.cond.page = 1;
      }
      currency_category_index_request(this.cond)
        .then((s) => {
          this.loading = false;
          if (s.status === 0) {
            this.ftable_data = s.result.data;
            this.ftotal = s.result.total;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    details_currency_category(id) {
      this.fid = id;
      this.fdialogFormVisible = true;
      currency_category_details_request(id)
        .then((s) => {
          if (s.status === 0) {
            this.fcurrency_category_details_data = s.result;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogExit() {
      this.fdialogFormVisible = false;
      this.fid = 0;
      this.edit_type = 0;
    },
  },
  filters: {},
  props: {},
  created() {
    this.get_currency_category_index();
  },
  destoryed() {},
  mounted() {},
  updated() {},
  components: {
    CurrencyCategorySearchBarComponent,
    CommonTableComponent,
    CommonPageComponent,
    CurrencyCategoryEditComponent,
  },
  watch: {},
};
</script>

<style lang="less"></style>
